import React from "react";

const EditIcon = () => {
    return (
        <svg
            width="20"
            height="22"
            viewBox="0 0 20 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1 8.10986V13.8799C1 15.9999 1 15.9999 3 17.3499L8.5 20.5299C9.33 21.0099 10.68 21.0099 11.5 20.5299L17 17.3499C19 15.9999 19 15.9999 19 13.8899V8.10986C19 5.99986 19 5.99986 17 4.64986L11.5 1.46986C10.68 0.989863 9.33 0.989863 8.5 1.46986L3 4.64986C1 5.99986 1 5.99986 1 8.10986Z"
                stroke="#161616"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M10 14C10.7956 14 11.5587 13.6839 12.1213 13.1213C12.6839 12.5587 13 11.7956 13 11C13 10.2044 12.6839 9.44129 12.1213 8.87868C11.5587 8.31607 10.7956 8 10 8C9.20435 8 8.44129 8.31607 7.87868 8.87868C7.31607 9.44129 7 10.2044 7 11C7 11.7956 7.31607 12.5587 7.87868 13.1213C8.44129 13.6839 9.20435 14 10 14V14Z"
                stroke="#161616"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};

export default EditIcon;
